import { DxTradeOrderType, DxTradeOrderTypes, DxTradeSide } from '@model/DxTrade.types'

export const determineOrderType = (
  priceCondEnabled: boolean,
  targetPrice: number | '',
  currentPrice: number | undefined,
  side: DxTradeSide
): DxTradeOrderType | undefined => {
  if (currentPrice == undefined) {
    return
  }

  if (!priceCondEnabled || targetPrice === '') {
    return DxTradeOrderTypes.MARKET
  }

  if (side === 'BUY') {
    return targetPrice > currentPrice ? DxTradeOrderTypes.STOP : DxTradeOrderTypes.LIMIT
  } else {
    return targetPrice < currentPrice ? DxTradeOrderTypes.STOP : DxTradeOrderTypes.LIMIT
  }
}

export const getMarginRequiredDisplay = (
  marginRequired?: number | null,
  freeMargin?: number | null
): string => {
  if (marginRequired == null) return ''

  const base = `${marginRequired}`

  if (freeMargin == null || marginRequired === 0) {
    return base
  }

  const ratio = (marginRequired / freeMargin) * 100
  if (!Number.isFinite(ratio)) {
    return base
  }

  const percent = ratio.toFixed(2)
  return `${base} (${percent}%)`
}
